// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1607":"14d5dacf","3579":"14d5dacf"}[chunkId] + ".chunk.css";
};